<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.seedingPositionBind" type="confirm" width="40%" @confirm="confirm">
    <vxe-form ref="form" :data="view" border span="12" title-align="center" title-background>
      <vxe-form-item field="container.no" title="business.label.containerNo"/>
      <vxe-form-item :item-render="{name:'VxeInput',events:{click:()=>this.onLocationSelect(),clear:()=>this.onLocationChange([])}}" field="seedingPosition.no" title="business.label.seedingPosition"/>
      <location-modal ref="locationModal" @change="onLocationChange"/>
    </vxe-form>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import api from '@/api'
import { ContainerCommand } from '@/api/dto/command/ContainerCommand'
import { Location } from '@/api/dto/common/Location'
import LocationModal from '@/views/modal/LocationModel.vue'

export default {
  components: { LocationModal },
  data() {
    return {
      visible: false,
      loading: false,
      view: new ContainerCommand(),
      seedingPosition: new Location()
    }
  },
  methods: {
    onLocationSelect() {
      this.$refs.locationModal.open({ zoneType: 5 })
    },
    onLocationChange(values) {
      this.seedingPosition = new Location(values[0])
    },
    open(view) {
      this.visible = true
      if (view) {
        Object.assign(this.view, view)
      }
    },
    confirm() {
      this.loading = true
      const args = {
        rackNo: this.view.container.no,
        locationNo: this.seedingPosition.no
      }
      post(api.containerBindSeedingPosition, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>